
import React from 'react';
import FortiLexReports from './components/FortiLexReports';
import './App.css';

function App() {
  return (
    <div className="App">
      <FortiLexReports />
    </div>
  );
}

export default App;
